import React from "react";
import MobileACHTransfersFromTableRow from "components/shared/widgets/ACHWidgets/MobileACHTransfersFromTableRow";
import { MobileNoEntriesTableRow } from "components/shared/views/TableView/components/MobileNoEntriesTableRow";
import "./styles.css";

/**
 * @function MobileACHTransfersFromTable
 * @return {React.Component}
 * @exported true
 * @description - This is the "One Time ACH From" mobile main table view for the OneTimeACHPaymentPage.
 */
export default function MobileACHTransfersFromTable(props) {
    const achFromAccounts = props.achFromAccounts ?? [];
    const onACHFromAccountChange = props.onACHFromAccountChange ?? (() => {});
    const onACHFromAccountDelete = props.onACHFromAccountDelete ?? (() => {});

    const rows = achFromAccounts.accounts.reduce((acc, item) => {
        acc.push(
            <MobileACHTransfersFromTableRow key={ item.id } achFromAccount={ item } onACHFromAccountChange={ onACHFromAccountChange } onACHFromAccountDelete={ onACHFromAccountDelete } />
        );
        return acc;
    }, []);
    const hasRows = rows.length > 0;

    return (
        <div className="mobile-one-time-ach-from-table">
            { !hasRows && <MobileNoEntriesTableRow /> }
            { hasRows && rows }
        </div>
    )
}
